<template>
  <div class="summary-row">
    <div
      v-for="(item, index) in summaryItems"
      :key="index"
      class="summary-item">
      <span class="label">{{ item.label }}</span>
      <span class="value">{{ item.value }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SummaryRow',
  props: {
    summaryData: {
      type: Object,
      required: true
    },
    summaryParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      summaryItems: []
    }
  },
  created() {
    this.getSummaryItems()
  },
  methods: {
    getSummaryItems() {
      const type = this.summaryParams.statisticalType
      // 根据类型生成配置项
      const getSummaryConfig = (type) => {
        const baseItems = [
          { label: '巡查次数：', key: 'scanCheckNum', unit: '次' },
          { label: '合法车辆数(已备案-已传数据)：', key: 'compliantVehicleNum', unit: '辆' },
          { label: '非法车辆数(未备案-已传数据)：', key: 'notCompliantVehicleNum', unit: '辆' },
          { label: '已备案-未传数据车辆数：', key: 'registeredCount', unit: '辆' },
          { label: '未备案-未传数据车辆数：', key: 'notRegisteredCount', unit: '辆' }
        ]
        return type === 1 ? [
          { label: '合计：车企总数：', key: 'totalBrands', unit: '家' },
          ...baseItems
        ] : [
          { label: '合计：巡查人员：', key: 'totalPerson', unit: '人' },
          ...baseItems,
          { label: '车管所二维码数：', key: 'licenseCode', unit: '辆' },
          { label: '无效二维码数：', key: 'invalidCode', unit: '辆' }
        ]
      }
      // 使用更简洁的 ?? 运算符（支持 null/undefined）
      const formatValue = (value, unit) => `${value ?? 0} ${unit}`
      this.summaryItems = getSummaryConfig(type).map(item => ({
        label: item.label,
        value: `${formatValue(this.summaryData[item.key], item.unit)}`
      }))
    }
  }
}

</script>

<style scoped lang="less">
.summary-row {
  display: flex;
  align-items: center;
  gap: 24px; /* 控制项间距 */
  font-weight: bold;
  padding: 16px;
  background: #f8decd;
  border-radius: 4px;
  .summary-item {
    display: flex;
    align-items: center;
    font-size: 15px;
  }
  .label {
    min-width: 80px;
    color: #3c3e43;
  }
  .value {
    color: #2b2b2d;
  }
}
</style>
